import { inject, Injectable } from '@angular/core';
import {
  ITrackEventPayload,
  ITrackMetricPayload,
  ITrackRequestPayload,
} from '@epicuro-next/models/platform/monitoring';

import { AbstractAnalyticsService } from '../../abstract/abstract-analytics.service';

import { AppInsightsService } from './app-insights.service';

/**
 * AppInsights service for analytics
 */
@Injectable()
export class AppInsightsAnalyticsService extends AbstractAnalyticsService {
  private appInsightsService = inject(AppInsightsService);

  /**
   * Tracks a specific event.
   * @param trackEventPayload
   */
  public trackEvent(trackEventPayload: ITrackEventPayload) {
    this.appInsightsService.instance.trackEvent(trackEventPayload);
  }

  /**
   * Tracks the payload of a request
   * @param trackRequestPayload
   */
  public trackRequestMetrics(trackRequestPayload: ITrackRequestPayload) {
    this.appInsightsService.instance.trackDependencyData(trackRequestPayload);
  }

  /**
   * Tracks a numeric metric (e.g. a Core Web Vital).
   * @param trackMetricPayload
   */
  public trackMetric(trackMetricPayload: ITrackMetricPayload) {
    this.appInsightsService.instance.trackMetric(
      {
        name: trackMetricPayload.name,
        average: trackMetricPayload.average,
      },
      trackMetricPayload.properties,
    );
  }
}
